<template>
<div class="col backgroundForm">
    <div class="col col-md-6 offset-md-3">
        <div class="alert alert-success" role="alert">
            <h4 class="alert-heading">Impresion de Matricula</h4>
            <p>Indique su {{ searchTypeR }}</p>
            <hr>
        </div>

        <form @submit.prevent="searchBoatPrint">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-success active" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearchR"  value="enrollment" checked> Nombre
                </label>
                <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearchR" value="name"> Matricula
                </label>
            </div>

            <div class="form-group"> 
                <label for="nombreEmbarcacion">{{ searchTypeR }}</label>
                <input type="text" class="form-control" id="enrollment_boat_r" v-model="enrollment_boat_p" :placeholder="searchTypeR" autocomplete="off">
                <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeR }} </small>
            </div>
            <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" >Buscar</button>
        </form>        
    </div>
    <br><br>
    <transition name="fade" mode="out-in">
        <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="statusSearchR">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th scoped="col">#</th>
                        <th scoped="col">Nombre Embarcacion</th>
                        <th scoped="col">Tipo</th>
                        <th scoped="col">Matricula</th>
                        <th scoped="col">Caracteristicas</th>
                        <th scoped="col">Impresion</th>                        
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(boat, index) in boatsP" :key="boat.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ boat.name_boat }}</td>
                        <td>{{ boat.detail_boat }}</td>
                        <td v-if="boat.enrollment">{{ boat.enrollment }}</td>
                        <td v-else>{{ boat.enrollment_old }}</td>
                        <td align="center"><button class="btn btn-outline-warning" data-toggle="modal" @click="mShowBoat(boat)"><font-awesome-icon icon="folder-open" /></button></td>
                        <td align="center"><button class="btn btn-outline-info" @click="mShowOrder(boat.id_boat)"><font-awesome-icon icon="print" /></button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </transition>
    <modal-ship :id-modal-data="idModalData" :ship="boatSelect" :name-ship="boatSelect.nameShip"></modal-ship>
    <modal-loading :id-modal="idModalLoad" :title="titleLoad" :status-send="sendRequest"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

import modalShip from './ViewDtsShip';
import modalLoading from '../modal/modalLoading';

export default {
    name:'print-enrollment',
    data(){
        return{
            optionSearchR:'name',
            enrollment_boat_p:null,
            statusSearchR:false,
            boatsP:[],
            idModalData:'dtsGralShipP',
            boatSelect:{
                nameShip:null,
                enrollment:null,
                enrollment_old:null,
                type:null,
                propulsion:null,
                trn:null,
                trb:null,
                port:null
            },
            codeAutorization:0,
            idModalLoad:'loadPrintAuth',
            titleLoad:'Verificando',
            sendRequest:true
        }
    },
    methods:{
        mShowOrder(e){
            let message = {
                title: 'Codigo de Verificacion',
                body: `Para poder realizar la impresion de la matricula indique el codigo de autorizacion proporcionado`,
            };
            let options ={
                promptHelp:'Codigo de Autorizacion'
            }
            // console.log(`el id de boat es ${e}`);
            this.codeAutorization=null;
            let nca=new Promise((resolve, reject)=>{
                this.$dialog
                .prompt(message, options)
                .then(dialog => {
                    // Triggered when proceed button is clicked
                    // Show an alert with the user's input as the message
                    this.codeAutorization=dialog.data ? dialog.data : null
                    // this.$dialog.alert(dialog.data || '[empty]')
                    resolve(this.codeAutorization);
                })
                .catch(() => {
                    // Triggered when dialog is dismissed by user
                
                    console.log('peticion rechazada');
                    toastr.warning('No se ha enviado la peticion', 'Advertencia')
                });
            })
            
            nca.then( async (code)=>{

                if(code){
                    // activamos el loading de envio codigo
                    this.titleLoad="Verificando";
                    this.mShowModalPrint(this.idModalLoad);
                    let vc=await axios.get(`verifyCode/${e}/${code}?api_token=${Vue.auth.getToken()}`);
                    let rp = vc.data;
                    // console.log(rp);
                    setTimeout(()=>{
                        this.mCloseModalPrint(this.idModalLoad);
                        if(rp[0].status){
                            toastr.success('imprimiendo el certificado', 'Exito');
                            let codEnroll=rp[0].respuesta;
                            // abrir una ventana o bajar el archivo pdf de la matricula
                            this.mDownEnrollment(e, codEnroll);
                        }else{
                            toastr.error(rp[0].respuesta, 'Error');
                        }
                    }, 1500)
                    
                }else{
                    console.error('no hay codigo')
                    toastr.error('Indique el codigo proporcionado', 'Error')
                }
            })
        },
        mDownEnrollment(idb,cod){
            // recibimos el codigo y el id de la nave
            // this.titleLoad='Descargando';

            let url_report=btoa(`pdfEnrollmentShip/${idb}/${cod}`);
            let route = this.$router.resolve({path: `/report/${url_report}`});
            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');

        },
        searchBoatPrint(){            
            this.boatsP=[];
            this.statusSearchR=false;
            if(this.enrollment_boat_p){
                
                // axios.get(`searchShipRectification/${this.optionSearchR}/${this.enrollment_boat_r}/${this.cSessionUser.portId}`)
                axios.get(`searchEnrollPrint/${this.optionSearchR}/${this.enrollment_boat_p}/${this.cSessionUser.portId}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    if(res.data.length > 0){
                        this.boatsP=res.data;
                        // console.log(this.boatsP)
                        this.statusSearchR=true;
                    }else{
                        toastr.info('No hemos encontrado aproximaciones', 'Advertencia')
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            this.optionSearchR=radioV;
        },
        mShowBoat(e){
            // console.log(e);
            this.boatSelect.nameShip=e.name_boat;
            this.boatSelect.enrollment=e.enrollment;
            this.boatSelect.enrollment_old=e.enrollment_old;
            this.boatSelect.type=e.detail_boat;
            this.boatSelect.propulsion=e.detail_propulsion
            this.boatSelect.trn=e.trn;
            this.boatSelect.trb=e.trb;
            this.boatSelect.port=this.cSessionUser.name_port;
            // console.log(this.boatSelect);
            setTimeout(()=>{
                this.mShowModalRec(this.idModalData);
            },1000);            
        },
        mShowModalPrint(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalPrint(idM){
            $('#'+idM).modal('hide');
        }
    },
    computed:{
        searchTypeR(){
            switch(this.optionSearchR){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-ship':modalShip,
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/matriculacion/PrintEnrollment.vue